module.exports = __webpack_public_path__ + "img/Zuckerwatte.054a818a.svg";